import { camelcaseKeys } from 'src/utils/camelize-keys';
import { decamelizeKeys } from 'src/utils/decamelize-keys';

import {
  associationsToId,
  associationsToIds,
  dateToTimestamp,
  removeReadOnlyFields,
  timestampToDate,
} from '../../utils/fieldNormalizers';
import { normalizeUser } from '../user/normalizers';

import { Appointment, EligibilityCheck, WaitListEntry } from './_types';

const readOnlyFields = [
  'created_at',
  'updated_at',
  'location_name',
  'links',
  'plan_workout_ids',
  'service_name',
  'is_group_class',
  'calendar_id',
  'platform_id',
  'cancellation_fee',
  'noshow_fee',
  'disable_cancellations',
  'primary_trainer_names',
  'secondary_trainer_names',
  'trainer_names',
  'visits',
  'entries',
];

export function normalizeAppointment(appointment): Appointment {
  const camelized = camelcaseKeys(appointment, { deep: true });
  return {
    ...camelized,
    startTime: timestampToDate(camelized.startTime),
    endTime: timestampToDate(camelized.endTime),
  };
}

export function normalizeCheckin(checkin) {
  const camelized = camelcaseKeys(checkin, { deep: true });
  camelized.user = normalizeUser(camelized.user);
  return camelized;
}

export function normalizeEligibilityCheck(elgibilityCheck): EligibilityCheck {
  return camelcaseKeys(elgibilityCheck, { deep: true });
}

export function normalizeWaitListEntry(waitListEntry): WaitListEntry {
  return camelcaseKeys(waitListEntry, { deep: true });
}

export function denormalizeWaitListEntry(
  waitListEntry: Partial<WaitListEntry>
) {
  return decamelizeKeys(waitListEntry, { deep: true });
}

export function denormalizeAppointment(appointment: Partial<Appointment>) {
  let decamelized = decamelizeKeys(appointment, { deep: true });

  decamelized = associationsToId(decamelized, ['service', 'location']);
  decamelized = associationsToIds(decamelized, [
    'primary_trainers',
    'secondary_trainers',
  ]);

  removeReadOnlyFields(decamelized, readOnlyFields);

  return {
    ...decamelized,
    start_time: dateToTimestamp(decamelized.start_time),
    end_time: dateToTimestamp(decamelized.end_time),
  };
}
